<template>
  <div>
    <div v-if="index === 0 && currentPage !== 1" class="card-list-body cursor-pointer" @click="emitShowPreviousEvent">
      <p>Mostrar anteriores<span><i class="pl-2 bx bxs-up-arrow"></i></span></p>
    </div>

    <div :class="['justify-between', cardSize]" ref="card">
      <div :class="[cardClass, 'p-2 flex flex-col leading-normal']">
        <div class="flex" id="inside-card">

          <!-- Imagen -->
          <div class="flex flex-wrap justify-center one">
            <div id="img-box">
              <img :src="imageSrc" :alt="localContent.descripcion" loading="lazy"
                class="img-responsive product-image rounded" @error="imageSrc = altImageSrc" @click="abrirModalProducto"
                width="105" role="button" oncontextmenu="return false" />
            </div>
          </div>

          <!-- Información del producto -->
          <div class="parent w-full">
            <div class="div1">
              <div class="flex justify-between w-full flex-wrap">

                <!-- Input + info -->
                <div class="grid grid-cols-[1fr] gap-2 items-center w-full">
                  <div class="grid grid-cols-1 gap-2 items-center w-full">
                    <div class="grid grid-cols-1 md:grid-cols-[6fr_1fr] gap-2 items-center w-full">
                      <cart-input type="number" v-model="inputValue" icon="bx bx-edit-alt" text="Editar cantidad"
                        :value="inputValue" :value2="inputValue2" :content="content" :CampoVmdInv="CampoVmdInv"
                        :hasDiscount="true" :hasInedexesDiscount="true" :hasNewCost="true" @add-to-cart="handleCart"
                        @quality="updateValue" @discount="updateDiscountItem" @open-modal="inputModalHandler(content)"
                        @cost-updated="updateCostItem" @pending-change="onPendingChange" @sedes-status="handleSedesStatus"  />
                      <div class="flex items-center justify-end">
                        <button @click="removeItem(content)"
                          class="w-fit ml-2 px-2 py-1 rounded bg-red-100 text-red-600 hover:bg-red-200 flex items-center"
                          v-tooltip="'Eliminar del carrito'">
                          <i class="bx bx-trash text-md"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="grid xl:grid-cols-[1fr_1fr_1fr] grid-cols-1 gap-4">
                    <InfoLabel label="DESCRIPCIÓN" icon="bxs-capsule" :value="`${title} - ${localContent.codprod}`" />
                    <InfoLabel label="MOLECULA" icon="bx-dna" :value="localContent.molecula" />
                    <InfoLabel label="UNIDAD MOLECULA" icon="bx-shape-triangle" :value="localContent.unidadmolecula" />
                  </div>

                  <!-- Etiquetas de descuentos e IVA -->
                  <div class="flex flex-wrap items-center gap-2">
                    <DiscountTag v-if="(100 - content.total_indexado) > 0 && content.desc_indexados"
                      :value="100 - content.total_indexado" label="DI"
                      :tooltipHtml="$functions.tooltips.indexedDiscounts(content)" />
                    <DiscountTag v-if="localContent.iva > 0" :value="localContent.iva" label="IVA"
                      tooltip="Porcentaje de IVA agregado" />
                    <DiscountTag v-if="content.discountMarca > 0" :value="content.discountMarca" label="DN"
                      :tooltipHtml="$functions.tooltips.indexedDiscountsMarca(desc_indexados_marca)" />
                    <DiscountTag v-if="content.discountItem > 0" :value="content.discountItem" label="DP"
                      tooltip="Descuento negociado por el producto" />
                  </div>
                </div>

              </div>
            </div>

            <!-- Información extendida -->
            <div class="flex">
              <ProductoInfo :title="title" :content="content" :cardClass="cardClass" :cardSize="cardSize"
                :headerClass="headerClass" :index="index" :lastIndex="lastIndex" type="1" />
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="index === lastIndex && currentPage !== lastPage" class="card-list-body cursor-pointer"
      @click="emitShowMoreEvent">
      <p>Mostrar siguientes<span><i class="pl-2 bx bxs-down-arrow"></i></span></p>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProductoInfo from './cardContent/producto/ProductoInfo.vue';
import InfoLabel from './cardContent/InfoLabel.vue';
import DiscountTag from './cardContent/DiscountTag.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CardPedido',
  props: [
    'title', 'content', 'cardClass', 'cardSize', 'headerClass',
    'index', 'lastIndex', 'currentPage', 'lastPage',
    'CampoVmdInv', 'desc_indexados_marca'
  ],
  components: { ProductoInfo, InfoLabel, DiscountTag },
  emits: ['item-removed', 'contentUpdated', 'show-more', 'show-previous', 'open-input-modal', 'pending-change'],
  computed: {
    ...mapState('orders', ['cartItems'])
  },
  data() {
    const local = { ...this.content };
    local.unidadmolecula = local?.dataprod?.unidadmolecula ?? 'N/A';

    return {
      imageSrc: `${this.$imgProdUrl}/${local.barra}.jpg`,
      altImageSrc: `${this.$imgProdUrl}/noimagen.jpg`,
      inputValue: local.quantity,
      inputValue2: local.discountItem,
      localContent: local
    };
  },
  methods: {
    ...mapActions('orders', [
      'addToCart', 'fetchCartItemsQuantity',
      'removeOneFromCart', 'updateCartItemDiscount', 'updateCartItemQuantity', 'updateCartItemCost'
    ]),
    onPendingChange(payload) {

      const safe = {
        ...payload,
        key: this.localContent.barra
      };
      this.$emit('pending-change', safe);
    },

    handleSedesStatus({ item, barra }) {
      this.$functions.modals.openSedesStatusModal(
        this.$axios,
        this.$apiRoute,
        { item, barra }
      );
    },

    abrirModalProducto() {
      this.$functions.modals.openProductModal(
        this.$axios, this.$apiRoute,
        this.content.barra,
        this.imageSrc,
        this.altImageSrc
      );
    },

    inputModalHandler(content) {
      this.$emit('open-input-modal', content);
    },

    showToast(title, icon = 'success') {
      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      }).fire({ icon, title });
    },

    updateValue(quantity) {
      const parsedQty = parseFloat(quantity);
      this.inputValue = parsedQty;

      this.updateCartItemQuantity({
        product: { ...this.localContent, quantity: parsedQty },
        quantity: parsedQty,
        axios: this.$axios,
        apiRoute: this.$apiRoute
      })
        .then(() => {
          this.$emit('content-updated', { ...this.localContent, quantity: parsedQty });
        })
        .catch(err => {
          Swal.fire('Error', 'Error al actualizar cantidad', 'error');
          console.error(err);
        });
    },

    updateDiscountItem(value) {
      const discount = parseFloat(value).toFixed(2);
      if (discount < 0 || discount > 100) {
        return Swal.fire('Advertencia', 'El descuento debe estar entre 0 y 100.', 'warning');
      }

      const local = { ...this.localContent };
      local.unidadmolecula = local?.dataprod?.unidadmolecula ?? 'N/A';

      this.inputValue2 = discount;
      local.discountItem = discount;

      this.updateCartItemDiscount({
        product: { ...local },
        discount,
        axios: this.$axios,
        apiRoute: this.$apiRoute
      })
        .then(() => {
          this.showToast('Guardando cambios...', 'warning');
          this.$emit('content-updated', { ...local });
          this.$emit('discount', discount);
        })
        .catch(err => {
          Swal.fire('Error', 'Error al actualizar descuento.', 'error');
          console.error(err);
        });
    },

    updateCostItem(value) {
      const cost = parseFloat(value.new_cost);
      if (isNaN(cost) || cost <= 0) {
        Swal.fire('Error', 'El costo debe ser un número válido', 'error');
        return;
      }

      this.updateCartItemCost({
        product: this.localContent,
        cost,
        apiRoute: this.$apiRoute
      })
        .then(() => {
          this.showToast('Actualizando costo...', 'warning');
          this.localContent = { ...this.localContent, costo: cost };
          this.$emit('content-updated', { ...this.localContent });
        })
        .catch(err => {
          Swal.fire('Error', 'No se pudo actualizar el costo.', 'error');
          console.error(err);
        });
    },

    handleCart(product) {
      const quantity = parseFloat(this.inputValue);
      if (!quantity || quantity <= 0) {
        return Swal.fire('Ups!!!', 'La cantidad debe ser mayor a 0', 'error');
      }

      this.addToCart({
        axios: this.$axios,
        apiRoute: this.$apiRoute,
        router: this.$router,
        data: { ...product, quantity }
      });
    },

    removeItem(product) {
      Swal.fire({
        title: '¿Eliminar?',
        text: '¿Deseas eliminar este producto del carrito?',
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          this.showToast('Eliminando producto del carrito', 'warning');

          this.removeOneFromCart({
            index: product.barra,
            product,
            axios: this.$axios,
            apiRoute: this.$apiRoute
          })
            .then(() => {
              this.showToast('Producto eliminado del carrito');
              this.$emit('item-removed');
            })
            .catch(err => {
              Swal.fire('Error', 'No se pudo eliminar el producto.', 'error');
              console.error(err);
            });
        }
      });
    },

    emitShowMoreEvent() {
      this.$emit('show-more');
    },

    emitShowPreviousEvent() {
      this.$emit('show-previous');
    }
  },
  watch: {
    'content.barra'(val) {
      this.imageSrc = `${this.$imgProdUrl}/${val}.jpg`;
      this.altImageSrc = `${this.$imgProdUrl}/noimagen.jpg`;
    },
    'content.quantity'(val) {
      this.inputValue = val;
    },
    'content.discountItem'(val) {
      this.inputValue2 = val;
    },
    content(newVal) {
      this.localContent = { ...newVal };
    }
  },
  inheritAttrs: false
};
</script>
